















import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import { InjectReactive } from 'vue-property-decorator'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import BaseTooltip from '@/modules/shared/components/shared/kit/BaseTooltip.vue'
import { InvoiceCollectionTypeInAdmin } from '@/modules/invoice/models/invoice-collection.model'
import AdminInvoiceActions from '@/modules/invoice/components/admin/table/AdminInvoiceActions.vue'
import InvoiceStatusView from '@/modules/invoice/components/shared/InvoiceStatusView.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import InvoicePersonTypeView from '@/modules/invoice/components/shared/InvoicePersonTypeView.vue'
import PriceView from '@/modules/shared/components/shared/PriceView.vue'

@Component({
  components: {
    TextEllipsis,
    TesTr,
    TesTd,
    DateTooltipped,
    BaseTooltip
  }
})
export default class AdminInvoiceTableRow extends mixins<TesTableRow>(TesTableRow) {

  @InjectReactive()
  invoices!: InvoiceCollectionTypeInAdmin

  get fixedData() {
    return {
      statuses: this.invoices.statuses,
      personTypes: this.invoices.person_types,
      modelTypes: this.invoices.model_types,
      availableModelTypes: this.invoices.available_model_types
    }
  }

  columnComponents = {
    title: {
      component: TextEllipsis,
      handler: (value, row) => ({ text: row.title})
    },
    status: {
      component: InvoiceStatusView,
      handler: (value, row, withData) => ({ status: row.status, statuses: withData.statuses })
    },
    payable: {
      component: PriceView,
      handler: (value, row, withData) => ({ price: row.payable, noCurrency: true })
    },
    person_type: {
      component: InvoicePersonTypeView,
      handler: (value, row, withData) => ({ type: row.person_type, types: withData.personTypes })
    },
    user: {
      component: AdminUserInfoButton,
      handler: (value, row, withData) => ({ basicUser: row.user })
    },
    model_type: {
      component: InvoicePersonTypeView,
      handler: (value, row, withData) => ({ type: row.model_type, types: withData.modelTypes })
    },
    actions: {
      component: AdminInvoiceActions,
      handler: (value, row, withData) => ({ invoice: row, withData: withData })
    }
  }

}
